/**
 * Collapse order + geometry for the primary-nav fixed items (MUL-3702).
 * As screen height decreases, fixed items (Home, Scribe, Library, Tasks,
 * Templates) collapse bottom-to-top into the More dropdown alongside the
 * always-present overflow items (Patients, etc.).
 */

/**
 * Fixed primary-nav items in visual top-to-bottom order.
 * Templates collapses first; Home collapses last.
 */
export const PRIMARY_NAV_DISPLAY_ORDER = [
  'home',
  'scribe',
  'library',
  'tasks',
  'templates',
] as const;

export type PrimaryNavRailId = (typeof PRIMARY_NAV_DISPLAY_ORDER)[number];

/**
 * Collapse priority: Tasks first, Home last.
 */
export const PRIMARY_NAV_COLLAPSE_ORDER: readonly PrimaryNavRailId[] = [
  ...PRIMARY_NAV_DISPLAY_ORDER,
].reverse();

/**
 * `data-testid` for each fixed item — used to measure rendered heights.
 */
export const PRIMARY_NAV_TEST_IDS: Readonly<Record<PrimaryNavRailId, string>> = {
  home: 'sidebar-link-home',
  scribe: 'sidebar-link-view-sessions',
  library: 'sidebar-link-library',
  tasks: 'sidebar-link-view-tasks',
  templates: 'sidebar-link-templates',
};

export const PRIMARY_NAV_MORE_TEST_ID = 'sidebar-primary-nav-more';

/** Estimated height per item when not yet measured (~44px sidebar row). */
export const PRIMARY_NAV_ITEM_ESTIMATE_PX = 44;

/** Gap between items. */
export const PRIMARY_NAV_GAP_PX = 0;

/** Anti-oscillation hysteresis. */
export const PRIMARY_NAV_HYSTERESIS_PX = 6;

/**
 * Exit duration of a folding fixed item. The provider waits this long before
 * handing the cascade to the footer rail, so the two must stay in lockstep.
 */
export const PRIMARY_NAV_COLLAPSE_EXIT_MS = 180;
